import React, { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { AttachFile } from '@material-ui/icons';
import {
  IconButton,
  CircularProgress,
  InputAdornment,
  TextField
} from '@material-ui/core';
import CryptoJS from 'crypto-js';

const HashCalculator = (props) => {
  const [value, setValue] = useState(props.formData || '');
  const [hashing, setHashing] = useState(false);

  useEffect(() => {
    setValue(props.formData || '');
  }, [props]);

  const onFileChange = async event => {
    setHashing(true);
    const file = await readFileAsync(event.target.files[0]);
    const SHA256 = CryptoJS.algo.SHA256.create();
    const wordBuffer = CryptoJS.lib.WordArray.create(file);
    SHA256.update(wordBuffer);
    const hash = SHA256.finalize().toString();
    setValue(hash);
    props.onChange(hash);
    setHashing(false);
  };

  const onTextChange = (e) => {
    const value = e.target.value;
    setValue(value);
    props.onChange(value || undefined);
  };

  const readFileAsync = file => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsArrayBuffer(file);
    });
  };

  const EndAdornment = () => {
    return (
      <InputAdornment>
        {hashing
          ? <CircularProgress size={22} />
          : (
            <label>
              <IconButton component='span'>
                <AttachFile style={{ fontSize: 24 }} />
              </IconButton>
              <input type='file' style={{ display: 'none' }} onChange={onFileChange} />
            </label>
          )
        }
      </InputAdornment>
    );
  };

  return (
    <TextField
      label={props.schema.title || props.name}
      value={value}
      onChange={onTextChange}
      required={props.required}
      disabled={props.disabled}
      readOnly={props.readonly}
      autoFocus={props.autofocus}
      InputProps={{
        endAdornment: <EndAdornment />
      }}
    />
  );
};

HashCalculator.propTypes = {
  onChange: PropTypes.func.isRequired,
  schema: PropTypes.object,
  name: PropTypes.string.isRequired,
  formData: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readonly: PropTypes.bool,
  autofocus: PropTypes.bool
};

export default memo(HashCalculator);
